'use strict';

;( () => {
    document.addEventListener( 'alpine:init', () => {

        Alpine.data( 'mainStage', () => ({

            paused      : false,
            videoPlaying: false,
            width       : 0,
            height      : 0,
            videoIframe : null,
            videoEl     : null,

            init() {
                this.width       = this.$el.offsetWidth;
                this.height      = this.$el.offsetHeight;
                this.videoIframe = this.$el.querySelector( 'iframe' );
                this.videoEl     = this.$el.querySelector( 'video' );

                if ( this.videoIframe ) {
                    window.addEventListener( 'message', ( event ) => {
                        if ( 'https://player.vimeo.com' !== event.origin ) {
                            return;
                        }

                        try {
                            const data = JSON.parse( event.data );

                            if ( 'ready' === data.event ) {
                                this.videoIframe.contentWindow.postMessage(
                                    JSON.stringify({ method: 'addEventListener', value: 'play' }),
                                    'https://player.vimeo.com'
                                );
                            }

                            if ( 'play' === data.event ) {
                                this.videoPlaying = true;
                            }
                        } catch ( e ) {
                            // Ignore non-Vimeo messages
                        }
                    });

                    if ( this.getVimeoSrc().includes( 'vimeo.com' ) ) {
                        this.setupVimeo();
                    } else {
                        document.addEventListener('cmplz_enable_category', (e) => {
                            if (e.detail.category === 'statistics' || e.detail.service === 'vimeo') {
                                setTimeout(() => this.setupVimeo(), 100);
                            }
                        });
                    }
                }
            },

            getVimeoSrc() {
                if ( ! this.videoIframe ) {
                    return '';
                }

                if ( this.videoIframe.dataset.srcCmplz ) {
                    return this.videoIframe.dataset.srcCmplz;
                }

                const src = this.videoIframe.getAttribute( 'src' ) || '';

                return src.includes( 'about:blank' ) ? '' : src;
            },

            setupVimeo() {
                if ( ! this.videoIframe || ! this.getVimeoSrc().includes( 'vimeo.com' ) ) {
                    return;
                }

                const src = this.videoIframe.getAttribute( 'src' ) || '';

                if ( this.videoIframe.contentWindow && ! src.includes( 'about:blank' ) ) {
                    this.videoIframe.addEventListener( 'load', () => {
                        this.sendPing();
                    }, { once: true } );

                    if ( this.videoIframe.readyState === 'complete' ) {
                        this.sendPing();
                    }
                }
            },

            sendPing() {
                this.videoIframe.contentWindow.postMessage(
                    JSON.stringify({ method: 'ping' }),
                    'https://player.vimeo.com'
                );
            },

            get isPortrait() {
                return 9 / 16 < this.height / this.width;
            },

            onResize() {
                this.width  = this.$el.offsetWidth;
                this.height = this.$el.offsetHeight;
            },

            toggleVideo() {
                this.$el.blur();

                if ( this.videoEl ) {
                    if ( this.paused ) {
                        this.videoEl.play();
                    } else {
                        this.videoEl.pause();
                    }

                    this.paused = ! this.paused;

                    return;
                }

                if ( ! this.videoIframe || ! this.getVimeoSrc().includes( 'vimeo.com' ) ) {
                    return;
                }

                const method = this.paused ? 'play' : 'pause';

                this.videoIframe.contentWindow.postMessage(
                    JSON.stringify({ method }),
                    'https://player.vimeo.com'
                );

                this.paused = ! this.paused;
            },
        }) );
    });
})();